import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import {
  ReferenceDataGeneralList,
  type ReferenceInboxColumn,
} from '../../parameters/ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { usePmsMeasurementResults, type PmsMeasurementResult } from './useData';

const List: React.FC = () => {
  const { colors } = useTheme();
  const formatDate = moduleConfig.utils.formatDate;

  const columns = useMemo<ReferenceInboxColumn<PmsMeasurementResult>[]>(
    () => [
      {
        key: 'code',
        header: 'Code',
        className: 'whitespace-nowrap',
        render: (row) => (
          <span className={cn('font-medium font-mono text-xs tracking-wide', colors.text)}>
            {row.code}
          </span>
        ),
      },
      {
        key: 'name',
        header: 'Name',
        render: (row) => <span className={cn('font-medium', colors.text)}>{row.name}</span>,
      },
      {
        key: 'sortOrder',
        header: 'Order',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => <span className={colors.textMuted}>{row.sortOrder}</span>,
      },
      {
        key: 'isActive',
        header: 'Active',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Yes' : 'No'}</Badge>
        ),
      },
      {
        key: 'createdAt',
        header: 'Created',
        className: 'hidden whitespace-nowrap lg:table-cell',
        render: (row) => <span className={colors.textMuted}>{formatDate(row.createdAt)}</span>,
      },
    ],
    [colors.text, colors.textMuted, formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={usePmsMeasurementResults}
      columns={columns}
      defaultSort={{ key: 'sortOrder', direction: 'asc' }}
      newLabel="New measurement result"
      getRowLabel={(row) => row.name || row.code}
      loadingLabel="Loading measurement results…"
    />
  );
};

export default List;
